'use strict';

angular.module('membership')
  .controller('UserGroupListCtrl', [
    '$scope', 'userGroupListViewModel', function ($scope, viewModel) {

      $scope.vm = new viewModel();
    }
  ]);